import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSession';
import toast from 'react-hot-toast';

export const Home = () => {
  const navigate = useNavigate();
  const [joinCode, setJoinCode] = useState('');
  const [role, setRole] = useState<'A' | 'B'>('B');
  const [loading, setLoading] = useState(false);
  const { createSession } = useSessionStore();

  const handleCreateSession = async () => {
    setLoading(true);
    const userId = 'user-' + Date.now();
    const sessionId = await createSession(userId);
    setLoading(false);

    if (sessionId) {
      navigate(`/session/${sessionId}?role=A`);
    } else {
      toast.error('Failed to create session');
    }
  };

  const handleJoinSession = async (e: React.FormEvent) => {
    e.preventDefault();
    if (joinCode.length < 6) {
      toast.error('Please enter a valid session code');
      return;
    }
    navigate(`/session/${joinCode.toUpperCase()}?role=${role}`);
  };

  return (
    <div className="home">
      <div className="hero" style={{ textAlign: 'center', padding: '3rem 0' }}>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>
          Connect. Play. <span style={{ color: 'var(--secondary)' }}>Feel.</span>
        </h1>
        <p style={{ color: 'var(--text-secondary)', fontSize: '1.125rem', marginBottom: '2rem' }}>
          Intimate games for queer couples with Lovense integration
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2rem', maxWidth: '800px', margin: '0 auto' }}>
        <div className="card">
          <h2 className="card-title">Create Session</h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
            Start a new game session and invite your partner
          </p>
          <button className="btn btn-primary btn-lg" onClick={handleCreateSession} disabled={loading}>
            {loading ? 'Creating...' : 'Create New Session'}
          </button>
        </div>

        <div className="card">
          <h2 className="card-title">Join Session</h2>
          <form onSubmit={handleJoinSession}>
            <div className="form-group">
              <label className="form-label">Session Code</label>
              <input
                type="text"
                className="form-input"
                value={joinCode}
                onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
                placeholder="Enter session code"
                style={{ textTransform: 'uppercase', textAlign: 'center', letterSpacing: '0.2em' }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Your Role</label>
              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  type="button"
                  className={`btn ${role === 'A' ? 'btn-primary' : 'btn-secondary'}`}
                  onClick={() => setRole('A')}
                  style={{ flex: 1 }}
                >
                  Partner A
                </button>
                <button
                  type="button"
                  className={`btn ${role === 'B' ? 'btn-primary' : 'btn-secondary'}`}
                  onClick={() => setRole('B')}
                  style={{ flex: 1 }}
                >
                  Partner B
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }}>
              Join Session
            </button>
          </form>
        </div>
      </div>

      <div style={{ marginTop: '3rem', textAlign: 'center' }}>
        <h3 style={{ marginBottom: '1rem' }}>Available Games</h3>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          {['Rhythm Match', 'Tease & Denial', 'Sync Challenge', 'Truth or Dare', 'Breathing'].map((game) => (
            <span
              key={game}
              style={{
                background: 'var(--bg-tertiary)',
                padding: '0.5rem 1rem',
                borderRadius: '20px',
                fontSize: '0.875rem'
              }}
            >
              {game}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
